export default(() => {
    return {
        checkIpFormat(ip){
            try{
                const block_number = 4;
                const splitted = ip.trim().split('.');
                if(splitted.length != block_number){ return false; }
                for(let i=0; i<block_number; i++){
                    const block = Number(splitted[i]);
                    if(isNaN(block)){ return false; }
                    if(block < 0 || block > 255){return false;}
                    if(i==block_number-1 && block == 0){ return false;}
                }
                return true;
            }catch{
                return false;
            }
        }
    }
})();